export enum NotificationChannelEnum {
  PUSH_NOTIFICATION = 'PushNotification',
  EMAIL_NOTIFICATION = 'EmailNotification',
  SMS_NOTIFICATION = 'SmsNotification'
}
